import React from 'react';
import BaseModalComponent from './BaseModal';
import SelectAsync from 'react-select/async';
import Uploader from 'react-images-upload';
//to use history.push
import { withRouter , Link } from 'react-router-dom';

const loadIssuesOptions = (inputValue, callback) => {
  setTimeout(() => {
    fetch("/api/organ/ajax/issue_list/",{
      method: "post",
      body: JSON.stringify({"term":inputValue}),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
    .then(records =>{
      let items = [];
      records.map(_record=>items.push({
        value: _record.person_id,
        label: "دوره " + _record.volume + ", شماره " + _record.issue + ", سال " + _record.aff_type ,
      }));
      callback(items);
    })
    
  }, 50);
};
class Document extends BaseModalComponent {
  constructor(props) {
    super(props, props.subModuleName, props.Id, props.ParentComponent);
    this.state.subModuleName = props.subModuleName;
    this.state.key = "id";
    this.onDropPdf = this.onDropPdf.bind(this);
    this.onDropWord = this.onDropWord.bind(this);
    this.state.pdf_select = false;
    this.state.word_select = false;
    this.state.extra_fields = {
      legal_person_id: props.LegalPersonId
    }
  }
  onDropPdf(picture) {
    if (picture.length === 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.state.form_data.record.media_pdf = reader.result;
      this.setState({pdf_select: true});
    }
    reader.readAsDataURL(file)
  }
  onDropWord(picture) {
    if (picture.length === 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.state.form_data.record.media_word = reader.result;
      this.setState({word_select: true});
    }
    reader.readAsDataURL(file)
  }
  componentWillReceiveProps(props){
    this.state.subModuleName = props.subModuleName;
    this.state.key = "id";
    this.state.extra_fields = {
      legal_person_id: props.LegalPersonId
    }
    super.componentWillReceiveProps(props);
  }
  getCaption(){
    if (this.state.subModuleName === "docs" ) return "سند";
    if (this.state.subModuleName === "cpapers" || this.state.subModuleName === "cpapers_main" ) return "مقاله";
    if (this.state.subModuleName === "jpapers" || this.state.subModuleName === "jpapers_main" ) return "مقاله";
    if (this.state.subModuleName === "reports" ) return "طرح";
  }  
  componentDidUpdate() {
    super.componentDidUpdate();
  }
  renderMessages(){
    if (this.isEmpty(this.state.messages)) return null;
    return (<div className="row">
      <div className="col-md-12">
        <div className="box box-info">
          <div className="box-header with-border">
            <h3 className="box-title">لیست خطاهای رخ داده</h3>
          </div>
          <div className="form-horizontal">
            <div className="box-body">
              <div className="form-group">
                {this.state.messages.map(message=>                  
                  <p className="col-sm-12"><span className="text-red" dangerouslySetInnerHTML={{ __html: message }}></span></p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);
  }
  renderBody() {
    if (this.state.form_data.record.document_draft_status === 2){
      return (
        <div className="row">
          <h4 className="alert alert-success text-center">محتوای ارسالی شما در تاریخ {this.g2j(this.state.form_data.record.edit_date,6)} مورد تایید قرار گرفت و بر روی پایگاه منشتر گردید وامکان ویرایش مجدد درخواست وجود ندارد.<a href={"https://civilica.com/doc/" + this.state.form_data.record.document_id + "/"} target="_blank">[مشاهده محتوای منتشر شده]</a></h4>
        </div>
      );
    }
    return [
        <div className="row">
          {!this.isBlank(this.state.form_data.record.document_id) ? <a href={"/doc/" + this.state.form_data.record.document_id + "/"} target="_blank">مشاهده صفحه مقاله بر روی سایت سیولیکا</a> : null}
        </div>
      ,
      <div className="row">
          {this.state.form_data.record.document_draft_status === 1 ?
            <h4 className="alert alert-warning text-center">شما محتوای {this.getCaption()} را در تاریخ {this.g2j(this.state.form_data.record.edit_date,6)} ویرایش نموده اید. لطفا تا زمان تایید/رد محتوا منتظر بمانید</h4>
          :null}
          {this.state.form_data.record.document_draft_status === 3 ?
            <h4 className="alert alert-danger text-center">محتوای ارسالی در تاریخ {this.g2j(this.state.form_data.record.edit_date,6)} از جانب مدیریت سامانه مورد تایید قرار نگرفت
            {!this.isBlank(this.state.form_data.record.note) ? [
              <p dangerouslySetInnerHTML={{ __html: "توضیحات کارشناس سیولیکا: " + this.state.form_data.record.note.replace(/\n/g,"<br/>") }}></p>
            ] : null}
            </h4>
          :null}
      </div>
      ,
      this.renderMessages()
      ,
      <div className="row">
        <div className="col-md-12">
          <div className="box box-info">
            <div className="box-header with-border">
              <h3 className="box-title">اطلاعات {this.getCaption()}</h3>
            </div>
            <div className="form-horizontal">
              <div className="box-body">
                {this.isBlank(this.state.form_data.record.document_id) && this.state.subModuleName === 'jpapers' &&
                  <div className="form-group">
                      <label className="col-sm-1 control-label"><span className="text-red">*</span> 
                      {"دوره"}
                      </label>
                      <div className="col-sm-5">
                        <SelectAsync
                          defaultValue={
                            this.state.form_data.record.LegalPerson ? [{ 
                              value: this.state.form_data.record.LegalPerson.person_id, 
                              label: this.state.form_data.record.document_sub_type === 1 ? this.state.form_data.record.LegalPerson.name : this.state.form_data.record.document_sub_type === 2 ? "دوره " + this.state.form_data.record.LegalPerson.volume + ", شماره " + this.state.form_data.record.LegalPerson.issue + ", سال " + this.state.form_data.record.LegalPerson.aff_type : this.state.form_data.record.LegalPerson.name
                            }] 
                            : 
                            !this.isNull(this.state.form_data.legalPerson) ? 
                            [{ 
                              value: this.state.form_data.legalPerson.person_id, 
                              label: this.state.form_data.record.document_sub_type === 1 ? this.state.form_data.legalPerson.name : this.state.form_data.record.document_sub_type === 2 ? "دوره " + this.state.form_data.legalPerson.volume + ", شماره " + this.state.form_data.legalPerson.issue + ", سال " + this.state.form_data.legalPerson.aff_type : this.state.form_data.legalPerson.name
                            }]
                            : null
                          }
                          isMulti={false}
                          placeholder={"دوره مورد نظر را انتخاب نمایید"}
                          defaultOptions
                          loadOptions={loadIssuesOptions}
                          onChange={e => this.state.form_data.record.legal_person_id = e.value}
                        />
                      </div>
                  </div>
                }

                <div className="form-group">
                  <label className="col-sm-1 control-label"><span className="text-red">*</span> عنوان</label>
                  <div className="col-sm-11">
                    <input type="text" className="form-control" placeholder="عنوان" onChange={(e) => { this.setFormValue(e, 'title') }} defaultValue={this.state.form_data.record.title} />
                  </div>
                </div>
                
                <div className="form-group">
                  <label className="col-sm-1 control-label">کلیدواژه ها</label>
                  <div className="col-sm-11">
                    <input type="text" className="form-control" placeholder="کلیدواژه ها" onChange={(e) => { this.setFormValue(e, 'keywords') }} defaultValue={this.state.form_data.record.keywords} />
                  </div>
                  <label className="col-sm-12">توجه: کلیدواژه ها را به صورت دقیق درج نموده و با کاما جدا نمایید</label>
                </div>
                
                <div className="form-group">
                  <label className="col-sm-1 control-label">زبان</label>
                  <div className="col-sm-2">
                    <select className="form-control" onChange={(e) => { this.setFormValue(e, 'language') }} defaultValue={this.state.form_data.record.language}>
                      <option value="1">فارسی</option>
                      <option value="2">انگلیسی</option>
                      <option value="3">عربی</option>
                      <option value="4">فرانسوی</option>
                      <option value="5">روسی</option>
                      <option value="6">آذری</option>
                      <option value="7">ترکی</option>
                    </select>
                  </div>
                  {this.state.subModuleName !== "jpapers" && this.state.subModuleName !== "jpapers_main" ? [
                    <label className="col-sm-1 control-label">نوع نشر</label>
                  ,
                    <div className="col-sm-2">
                      <select className="form-control" onChange={(e) => { this.setFormValue(e, 'present') }} defaultValue={this.state.form_data.record.present}>
                        <option value="">مشخص نشده</option>
                        <option value="1">شفاهی</option>
                        <option value="2">پوستر</option>
                        <option value="3">سی دی</option>
                        <option value="4">کارگاه</option>
                        <option value="5">چاپی</option>
                      </select>
                    </div>
                  ] : null}
                </div>

                <div className="form-group">
                  <label className="col-sm-1 control-label"><span className="text-red">*</span> چکیده</label>
                  <div className="col-sm-11">
                    <textarea
                      className="form-control"
                      style={{"height":"250px"}}
                      defaultValue={this.state.form_data.record.abstract}
                      onChange={e => {
                        this.state.form_data.record.abstract = e.target.value
                      }}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      ,
      
      <div className="row">
        <div className="col-md-12">
          <div className="box box-info">
            <div className="box-header with-border">
              <h3 className="box-title">فایل های {this.getCaption()}</h3>
            </div>
            <div className="form-horizontal">
              <div className="box-body">
                <div className="form-group">        
                  <div className="col-sm-6">          
                    <Uploader
                      withPreview={false}
                      className="paperMediaUploader"
                      withIcon={false}
                      withLabel={false}
                      buttonText='انتخاب فایل پی دی اف'
                      fileSizeError="حجم فایل انتخابی زیاد است"
                      fileTypeError="فرمت فایل انتخابی نامعتبر است"
                      onChange={this.onDropPdf}
                      accept="*"
                      imgExtension={['.pdf']}
                      singleImage={true}
                      maxFileSize={26214400}
                    />
                    {this.state.pdf_select === true ? <p className="text-green">فایل PDF جهت آپلود انتخاب شد</p>: null}
                    {this.state.form_data.record.id > 0 ? 
                      !this.isBlank(this.state.form_data.record.media_pdf) ?
                        <p className="text-green">فایلی با حجم {this.state.form_data.pdf_size} کیلوبایت آپلود شده است</p>
                      :
                        <p className="text-red">هنوز فایلی آپلود نشده است</p>
                    : 
                      null
                    }
                  </div>
                  <div className="col-sm-6">  
                    <Uploader
                      withPreview={false}
                      className="paperMediaUploader"
                      withIcon={false}
                      withLabel={false}
                      buttonText='انتخاب فایل ورد'
                      fileSizeError="حجم فایل انتخابی زیاد است"
                      fileTypeError="فرمت فایل انتخابی نامعتبر است"
                      onChange={this.onDropWord}
                      accept="*"
                      imgExtension={['.doc', '.docx']}
                      singleImage={true}
                      maxFileSize={26214400}
                    />
                    {this.state.word_select === true ? <p className="text-green">فایل WORD جهت آپلود انتخاب شد</p>: null}
                    {this.state.form_data.record.id > 0 ? 
                      !this.isBlank(this.state.form_data.record.media_word) ?
                        <p className="text-green">فایلی با حجم {this.state.form_data.word_size} کیلوبایت آپلود شده است</p>
                      :
                        <p className="text-red">هنوز فایلی آپلود نشده است</p>
                    : 
                      null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ,
      <div className="row">
        <div className="col-md-12">
          <div className="box box-info">
            <div className="box-header with-border">
              <h3 className="box-title">نویسندگان</h3>
            </div>
            <div className="form-horizontal">
              <div className="box-body">
                <p className="text-red">در ورود اسامی نویسندگان، عناوینی مانند "دکتر" ، "مهندس" ، "پروفسور" ، "ایت الله" ، "حجه الاسلام" و ... به هیچ عنوان وارد نشود و فقط نام و نام خانوادگی را درج نمایید.</p>
                <p className='text-red'>وارد کردن اطلاعات سمت نویسنده به صورت کامل و آدرس ایمیل برای همه نویسندگان الزامی است.</p>
                <h4><span className="text-red">*</span> نویسنده اول</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au1_fname') }} defaultValue={this.state.form_data.record.au1_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au1_lname') }} defaultValue={this.state.form_data.record.au1_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au1_email') }} defaultValue={this.state.form_data.record.au1_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au1_aff') }} defaultValue={this.state.form_data.record.au1_aff} />
                    </div>
                  </div>
                </div>
                
                <h4>نویسنده دوم</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au2_fname') }} defaultValue={this.state.form_data.record.au2_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au2_lname') }} defaultValue={this.state.form_data.record.au2_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au2_email') }} defaultValue={this.state.form_data.record.au2_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au2_aff') }} defaultValue={this.state.form_data.record.au2_aff} />
                    </div>
                  </div>
                </div>
                
                <h4>نویسنده سوم</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au3_fname') }} defaultValue={this.state.form_data.record.au3_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au3_lname') }} defaultValue={this.state.form_data.record.au3_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au3_email') }} defaultValue={this.state.form_data.record.au3_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au3_aff') }} defaultValue={this.state.form_data.record.au3_aff} />
                    </div>
                  </div>
                </div>
                
                <h4>نویسنده چهارم</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au4_fname') }} defaultValue={this.state.form_data.record.au4_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au4_lname') }} defaultValue={this.state.form_data.record.au4_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au4_email') }} defaultValue={this.state.form_data.record.au4_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au4_aff') }} defaultValue={this.state.form_data.record.au4_aff} />
                    </div>
                  </div>
                </div>
                
                <h4>نویسنده پنجم</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au5_fname') }} defaultValue={this.state.form_data.record.au5_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au5_lname') }} defaultValue={this.state.form_data.record.au5_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au5_email') }} defaultValue={this.state.form_data.record.au5_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au5_aff') }} defaultValue={this.state.form_data.record.au5_aff} />
                    </div>
                  </div>
                </div>
                
                <h4>نویسنده ششم</h4>
                <div className="col-sm-12" style={{"borderBottom":"dashed 2px gray","marginBottom":"15px","padding-left": "20px"}}>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">نام</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.setFormValue(e, 'au6_fname') }} defaultValue={this.state.form_data.record.au6_fname} />
                    </div>
                    <label className="col-sm-1 control-label">نام خانوادگی</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="نام خانوادگی" onChange={(e) => { this.setFormValue(e, 'au6_lname') }} defaultValue={this.state.form_data.record.au6_lname} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-1 control-label">ایمیل</label>
                    <div className="col-sm-2">
                      <input type="text" className="form-control" placeholder="ایمیل" onChange={(e) => { this.setFormValue(e, 'au6_email') }} defaultValue={this.state.form_data.record.au6_email} />
                    </div>
                    <label className="col-sm-1 control-label">سمت</label>
                    <div className="col-sm-5">
                      <input type="text" className="form-control" placeholder="سمت" onChange={(e) => { this.setFormValue(e, 'au6_aff') }} defaultValue={this.state.form_data.record.au6_aff} />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
  renderNormalView() {
    return (
      this.state.form_data.status === 4 ?
        this.renderNoLogin()
        :
        this.state.form_data.status === 2 ?
          this.renderNoAccess()
          :
          [
            this.renderBody()
            ,
            <div className="buttonHolder">
              <div className="btn-group">
                <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm(''); }}>ذخیره</button>
              </div>
            </div>
          ]
    );
  }
  render() {
    if (this.state.form_data === null || this.state.form_data === undefined) return null;
    if (this.state.form_data.status === 404) return this.render404();
    return this.renderNormalView();
  }
}
const DocumentEXP = withRouter(Document);
export default DocumentEXP;